module.exports = __webpack_public_path__ + "img/cloth_g3_shoe-08.f554342f.svg";